$(document).ready(function(){

  $('.yv-tab-item').click(function(){
    var tab_id = $(this).attr('data-collection-handle');
  
    $('.collection-button-wrapper').removeClass('active-tab');
  
    $("#"+tab_id).addClass('active-tab');
  });

  $('.hero_banner_wrapper').slick({
    dots: true,
    infinite: false,
    speed: 300,
    arrows:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade:true
      
  });

  //   $('.yv-product-card .custom_variant_option_list.op-ul').each(function(){
  //     var customProductId = $(this).attr('custom-product-id');
  //     if($(this).find('li').length > 0){
  //       $('[custom-product-id="'+customProductId+'"]').not('.slick-initialized').slick({
  //         infinite: false,
  //         slidesToShow: 5,
  //         slidesToScroll: 2,
  //         arrows:false,
  //         dots:false,
  //         autoplay:true,
  //         autoplaySpeed: 3000,
  //       });
  //     }
  // });

// $('.collection_list_col').slick({
//   dots: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 5,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
    
//   ]
// });

  
  
});

$(document).on('click', '.language_btn_js', function() {
  var data_lang = $('html').attr('lang');
  if (data_lang == "ar") {
    $('#localization_form select').val('en').trigger('change');
  } else if (data_lang == "en") {
    $('#localization_form select').val('ar').trigger('change');
  }
  $('#localization_form').submit();
});



$(document).ready(function() {
    $('.blog_details_top_col a[href*=\\#]').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(this.hash).offset().top - 200
        }, 500);
    });
});

// CWI NK
function initializeSwiper($swiperContainer) {
  var paginationElement = $swiperContainer.find('.swiper-pagination')[0];
  if($(window).width() >= 749){
    var swiperOptions = {
      direction: 'horizontal',
      loop: false,
      freeMode: false,
      allowTouchMove: false,
      slidesPerView: 1,
      preloadImages: true,
      autoplay: {
        delay: 500,
        disableOnInteraction: false,
      },
      pagination: {
        el: paginationElement,
        clickable: true,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true 
      },
    };
  }else{
    var swiperOptions = {
      direction: 'horizontal',
      loop: true,
      freeMode: false,
      allowTouchMove: true,
      slidesPerView: 1,
      preloadImages: true,
      autoplay: false,
      pagination: {
        el: paginationElement,
        clickable: true,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true 
      },
    };
  }
  $swiperContainer.on('mouseleave', function(){
    swiper.slideTo(0);
  }); 
  var swiper = new Swiper($swiperContainer[0], swiperOptions); 
}

$(document).on('mouseenter', '.image_main_inner', function() {
  if($(window).width() >= 749){
    if($(this).find('.swiper.js_image_slider').length){
      $(this).find('.swiper.js_image_slider').each(function() {
        initializeSwiper($(this));
      });
    }
  }
});

$(document).ready(function(){
  if($(window).width() <= 749){
    if($('.swiper.js_image_slider').length){
      $('.swiper.js_image_slider').each(function() {
        initializeSwiper($(this));
      });
    }
  }
});

$(document).on('click','.js_variant_product',function(){
  $(this).parents('.yv-product-card').find('.image_main_inner .first_image img').attr('src',$(this).attr('data-img-src-value'));
  
  var $parentProductCard = $(this).parents('.yv-product-card'),
      data__image_url_arry = $(this).attr('data__image_url_arry').split(','),
      new_image_slide = '<div class="swiper js_image_slider"><div class="swiper-wrapper">';

  var newProductUrl = $(this).attr("new-product-url");
  console.log("HERE::", $parentProductCard, newProductUrl);
  $parentProductCard.find('a.yv-product-title').attr('href',newProductUrl);
  $parentProductCard.find('a.yv-product-img').attr('href',newProductUrl);
  $parentProductCard.find('a.quickView').attr('href',newProductUrl);
  $parentProductCard.find('a.quickView').attr('data-href',newProductUrl);
  $parentProductCard.find('a.image-link').attr('data-href',newProductUrl);
  $parentProductCard.find('a.second-image-link').attr('data-href',newProductUrl);

  $.each(data__image_url_arry, function(index, imageURL) {
    new_image_slide += '<div class="swiper-slide single-image"><div class="image__inner"><a href="'+newProductUrl+'" class="second-image-link"><img src="' + imageURL + '" alt="Image" width="" height=""></a></div></div>';
  });
  
  new_image_slide += '</div><div class="swiper-pagination"></div></div>';
  
  $parentProductCard.find('.image_main_inner .secound_image').html(new_image_slide);
  
  var $newSwiperContainer = $parentProductCard.find('.secound_image .swiper.js_image_slider');
  setTimeout(function() {
      initializeSwiper($newSwiperContainer);
  }, 1000);

  // code to update main product url
});
